import React, { useEffect, useState } from 'react';
import { Box, Button, Grid, Alert, TextField, Typography } from '@mui/material';
import {
  IWizardFormStep,
  PrizeetAuthUser
} from '../../../../interface/interface';
import { useOrderManagementStore } from '../../../../zustandStore/store.ordermgt';
import SearchIcon from '@mui/icons-material/Search';
import { VariantSelector } from '../../../../components/VariantSelector/VariantSelector';
import { useOrderDataStore } from '../../../../zustandStore/store.order-data';

export const VariantListerStepForm = (props: IWizardFormStep) => {
  const { onNext, onPrevious } = props;
  const [selected, setSelected] = useState(false);

  const orderMgtStore = useOrderManagementStore((state) => state);
  const ordersStore = useOrderDataStore((state) => state);

  console.log(ordersStore.settings.orders);

  const handleNext = () => {
    if (selected) {
      onNext(); // Only proceed if an address is selected
    }
  };

  const handleBack = () => {
    // Reset the order
    ordersStore.actions.clearOrders();
    onPrevious();
  };

  return (
    <>
      {/* Display form-level errors if any */}

      <Grid
        sx={{
          flexDirection: 'column',
          gap: 2,
          width: 'auto'
        }}
        spacing={3}
      >
        <Grid spacing={3}>
          <Box
            sx={{
              padding: '2% 2%',
              width: '100%',
              border: '1px solid #e0e0e0',
              borderRadius: '8px'
            }}
          >
            <Box sx={{ mt: 3 }}>
              <VariantSelector
                onVariantSelect={(e) => {
                  setSelected(e > 0);
                }}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 3,
          mt: 5
        }}
        className="wizard-button"
      >
        <Button variant={'contained'} onClick={(e) => handleBack()}>
          Previous
        </Button>

        {}
        <Button
          disabled={ordersStore.settings.orders.length === 0}
          variant={'contained'}
          onClick={(e) => handleNext()}
        >
          Next
        </Button>
      </Box>
    </>
  );
};
